import React from 'react';
import { AlertDialog, AlertDialogBody, Button } from '@americanexpress/dls-react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

const WarningModal = ({ open, handleClose, externalLink, warningMessage }) => {
  const intl = useIntl();
  // Edge case: open should be boolean
  if (typeof open !== 'boolean' || !open) return null;
  // Edge case: handleClose should be a function
  const safeHandleClose = typeof handleClose === 'function' ? handleClose : () => {};
  // Edge case: externalLink should be a non-empty string and valid URL
  const isValidExternalLink = typeof externalLink === 'string' && externalLink.trim();
  return (
    <AlertDialog onClose={safeHandleClose} id="warning-dialog">
      <AlertDialogBody
        id="warning-dialog-body"
        className="margin-2-t"
        actionSlot={(
          <>
            <Button
              variant="secondary"
              onClick={safeHandleClose}
            >
              {intl.formatMessage({ id: 'view-all.warning-modal.dismiss', defaultMessage: 'Dismiss' })}
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                if (isValidExternalLink) {
                  window.location.href = externalLink;
                }
              }}
            >
              {intl.formatMessage({ id: 'view-all.warning-modal.continue', defaultMessage: 'Continue' })}
            </Button>
          </>
        )}
      >
        <p className="text-wrap">
          {intl.formatMessage({ id: 'view-all.warning-modal.warning-message', defaultMessage: warningMessage })}
        </p>
      </AlertDialogBody>
    </AlertDialog>
  );
};

WarningModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  externalLink: PropTypes.string,
  warningMessage: PropTypes.string,
};

WarningModal.defaultProps = {
  open: false,
  handleClose: () => {},
  externalLink: '',
  warningMessage: '',
};

export default WarningModal;
